import { ValueGetterParams } from '@ag-grid-enterprise/all-modules';
import { DistributorConfiguration } from 'data/distributorConfiguration/distributorConfiguration.types';

export const distributorCurrentStatus = (data: DistributorConfiguration): string => {
  const {
    listeners = [],
    destinations = [],
  } = data as DistributorConfiguration;

  const areAllListenersActive = listeners.every(({ status }) => status === 'ACTIVE');
  const areAllDestinationsActive = destinations.every(({ status }) => status === 'ACTIVE');

  const areAllListenersInactive = listeners.every(({ status }) => status === 'INACTIVE');
  const areAllDestinationsInactive = destinations.every(({ status }) => status === 'INACTIVE');

  let value = 'PARTIALLY_ACTIVE';

  if (areAllListenersActive && areAllDestinationsActive) {
    value = 'ACTIVE';
  } else if (areAllListenersInactive && areAllDestinationsInactive) {
    value = 'INACTIVE';
  }

  return value;
};

export const distributorValueGetter = ({ data }: ValueGetterParams): string => {
  return distributorCurrentStatus(data);
};

export default distributorValueGetter;
